module.exports = __webpack_public_path__ + "static/img/3s-platform-img7.87cb927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img7.png
// module id = NJT0
// module chunks = 0